import { useMemo } from 'react';
import {
  PassengerFormData,
  PassengerType,
  PassengerTypeKey,
} from 'app/pages/PassengerInfo/types';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { IHolidayPassenger } from 'app/pages/HolidayCheckout/types';

export interface PassengerCount {
  adults: number;
  child: number;
  infants: number;
  total: number;
  totalAdultAndChild: number;
  totalAdult: number;
  totalChild: number;
  totalInfants: number;
  textPassenger: string;
  room?: number;
}
export const usePassengerCount = (
  passengers: (IHolidayPassenger | PassengerFormData)[] = [],
  hotel?: {
    room: number;
    hotelCount: number;
  },
): PassengerCount => {
  const translations = useSelector(selectTranslations);
  const room = hotel?.room || 0;
  const hotelCount = hotel?.hotelCount || 0;
  return useMemo(() => {
    const result = passengers.reduce(
      (acc, p) => {
        const type = p.type ?? p.passengerType;
        switch (type) {
          case PassengerType.ADULT:
          case PassengerTypeKey.ADULT:
            acc.adults++;
            break;
          case PassengerType.CHILD:
          case PassengerTypeKey.CHILD:
            acc.child++;
            break;
          case PassengerType.INFANT:
          case PassengerTypeKey.INFANT:
            acc.infants++;
            break;
        }
        return acc;
      },
      { adults: 0, child: 0, infants: 0 },
    );
    const total = result.adults + result.child + result.infants;
    const totalAdultAndChild = result.adults + result.child;
    const totalAdult = result.adults;
    const totalChild = result.child;
    const totalInfants = result.infants;
    return {
      ...result,
      total,
      totalAdultAndChild,
      totalAdult,
      totalChild,
      totalInfants,
      room,
      textPassenger: [
        result.adults && `${result.adults} ${translations?.['b2b.txt.adult']}`,
        result.child && `${result.child} ${translations?.['b2b.txt.child']}`,
        result.infants &&
          `${result.infants} ${translations?.['b2b.txt.infant']}`,
        room > 0 &&
          hotelCount > 0 &&
          `${room} ${String(translations?.['b2b.txt.rooms']).toLowerCase()}`,
      ]
        .filter(Boolean)
        .join(', '),
    };
  }, [passengers, translations, hotelCount, room]);
};
